require('!file-loader?context=src/vendor/&name=[path][name].[ext]!./filerobot/index.html');
require('!file-loader?context=src/vendor/&name=[path][name].[ext]!./filerobot/filerobot-image-editor.min.js');
